import { defineMessages } from 'react-intl';

export default defineMessages({
  item : {
    id: 'promotion.category.type.item',
    defaultMessage: 'Item'
  },
  class : {
    id: 'promotion.category.type.class',
    defaultMessage: 'Class'
  },
  brand : {
    id: 'promotion.category.type.brand',
    defaultMessage: 'Brand'
  },
  facet : {
    id: 'promotion.category.type.facet',
    defaultMessage: 'Facet'
  }
});
